import React, { useState } from 'react';
import axios from 'axios';
import './FeedbackButton.css';

const FeedbackButton = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle'); // idle, sending, success, error
    const [errorMessage, setErrorMessage] = useState('');

    const hostname = window.location.hostname;
    const API_URL = (hostname === 'localhost' || hostname === '127.0.0.1')
        ? '/api/feedback'
        : 'https://buzzbus-production.up.railway.app/api/feedback';

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!message.trim() || message.trim().length < 5) {
            setErrorMessage('Please enter at least 5 characters');
            return;
        }

        setStatus('sending');
        setErrorMessage('');

        try {
            await axios.post(API_URL, {
                message: message.trim(),
                email: email.trim() || null
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            setStatus('success');
            setMessage('');
            setEmail('');

            // Auto-close after 2 seconds
            setTimeout(() => {
                setIsOpen(false);
                setStatus('idle');
            }, 2000);

        } catch (error) {
            setStatus('error');
            setErrorMessage('Failed to send feedback. Please try again.');
        }
    };

    const handleClose = () => {
        setIsOpen(false);
        setStatus('idle');
        setErrorMessage('');
    };

    return (
        <>
            {/* Floating Button */}
            <button
                className="feedback-fab"
                onClick={() => setIsOpen(true)}
                aria-label="Send Feedback"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                </svg>
            </button>

            {/* Modal Overlay */}
            {isOpen && (
                <div className="feedback-overlay" onClick={handleClose}>
                    <div className="feedback-modal" onClick={(e) => e.stopPropagation()}>
                        <button className="feedback-close" onClick={handleClose}>×</button>

                        <h3 className="feedback-title">Send Feedback</h3>
                        <p className="feedback-subtitle">
                            Report bugs, suggest features, or share your thoughts!
                        </p>

                        {status === 'success' ? (
                            <div className="feedback-success">
                                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                                </svg>
                                <p>Thanks for your feedback!</p>
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit}>
                                <textarea
                                    className="feedback-textarea"
                                    placeholder="What's on your mind?"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    rows={4}
                                    disabled={status === 'sending'}
                                />

                                <input
                                    type="email"
                                    className="feedback-email"
                                    placeholder="Your email (optional, for follow-up)"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    disabled={status === 'sending'}
                                />

                                {errorMessage && (
                                    <p className="feedback-error">{errorMessage}</p>
                                )}

                                <button
                                    type="submit"
                                    className="feedback-submit"
                                    disabled={status === 'sending'}
                                >
                                    {status === 'sending' ? 'Sending...' : 'Send Feedback'}
                                </button>
                            </form>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default FeedbackButton;
